// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__1EWhf","footer":"ModalInfo_footer__1hlwy"};